<app-cycle-time [time]="text" [autoIncrement]="autoIncrease"></app-cycle-time>
